import { Component, ElementRef, EventEmitter, Output, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, MessageService, ButtonLoader, AuthService } from '../../../core';
import { PedidoCancelamento } from './pedido-cancelamento';
import { PedidoCancelado } from './pedido-cancelado';
import { PedidoCancelamentoHttpService } from './services';
import { MotivoPerdaVendaSelectComponent } from '../../motivo-perda-venda/select';
import { PedidoCrudHttpService } from '../services/pedido-crud-http.service';
import { Pedido } from '../pedido';
import { take } from 'rxjs/operators';
import { isSimulacao } from '../../configuracoes/app/pedido/tipo-venda';
import { isOrigemLancamentoCadastroEcommerce } from '../../../models/origem-lancamento-cadastro';

interface Config {
    isSimulacao: boolean;
    isOrigemEcommerce: boolean;
}

@Component({
    selector: 'sgt-pedido-cancelamento-modal',
    templateUrl: './pedido-cancelamento-modal.component.html'
})
export class PedidoCancelamentoModalComponent implements OnInit {
    /** Configurações da modal */
    config: Config;
    /** Se é um usuário de perfil representante */
    isRepresentante: boolean;
    /** Pedido a ser cancelado */
    pedido: Pedido;
    /** Flag indicadorada se está carregando o pedido a ser cancelado */
    isLoading: boolean;
    /** Objeto de cancelamento do pedido */
    entity = new PedidoCancelamento(null);

    isOpen: boolean;
    elModal: any;
    @Output() afterCancel = new EventEmitter<PedidoCancelado>(); // Evento emitido após o cancelamento do pedido

    @ViewChild('modal', {static: true}) modal: ElementRef;
    @ViewChild('form') form: NgForm;
    @ViewChild('motivoCanceladoSelect') motivoCanceladoSelect: MotivoPerdaVendaSelectComponent;


    constructor(private el: ElementRef,
                private messageService: MessageService,
                private authService: AuthService,
                private pedidoCrudHttpService: PedidoCrudHttpService,
                private pedidoCancelamentoHttpService: PedidoCancelamentoHttpService) { }

    ngOnInit() {
        this.isRepresentante = this.authService.isRepresentante();
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.modal.nativeElement) as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                this.isOpen = true;
                e.stopPropagation();
            })
            .on('shown.bs.modal', async (e: any) => {
                try {
                    this.pedido = await this.findPedido(this.entity.id);
                    this.setConfig();
                    this.isLoading = false;
                    setTimeout(() => this.motivoCanceladoSelect?.setFocus(), 100);
                } catch (error) {
                    this.messageService.error(error.message, error.cause, error);
                    this.close();
                }

                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                this.isOpen = false;
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                this.clear();
                e.stopPropagation();
            });
    }

    /** Carrega o pedido a ser cancelado */
    private findPedido(idPedido: number): Promise<Pedido> {
        return new Promise<Pedido>((resolve, reject) => {
            this.pedidoCrudHttpService.find(idPedido)
                .pipe(take(1))
                .subscribe(
                    pedido => resolve(pedido),
                    (error: ApiError) => reject(error)
                );
        });
    }

    /** Seta as configurações da modal */
    private setConfig() {
        this.config = {
            isSimulacao: isSimulacao(this.pedido.tipoVenda),
            isOrigemEcommerce: isOrigemLancamentoCadastroEcommerce(this.pedido.origemLancamento) ?? false
        };
    }

    open(idPedido: number) {
        this.isLoading = true;
        this.entity = new PedidoCancelamento(idPedido);

        this.elModal.modal({keyboard: false, backdrop: 'static'});
    }

    private clear() {
        this.pedido = null;
        this.entity = null;
        this.isLoading = false;
    }

    close() {
        this.elModal.modal('hide');
    }

    /** Envia o cancelamento do pedido */
    cancel() {
        const btnCancelPedido = new ButtonLoader('#btnCancelPedido');
        btnCancelPedido.loading('Cancelando');

        if (this.form.valid) {
            this.pedidoCancelamentoHttpService.cancel(this.entity)
                .subscribe(
                    pedidoCancelado => {
                        const message = this.config.isSimulacao ? `Simulação ${pedidoCancelado?.numero} cancelada com sucesso` : `Pedido ${pedidoCancelado?.numero} cancelado com sucesso`;
                        this.messageService.success('', message);
                        btnCancelPedido.reset();
                        this.close();
                        this.afterCancel.emit(pedidoCancelado);
                    },
                    (error: ApiError) => {
                        const title = this.config.isSimulacao ? 'Erro ao cancelar a simulação' : 'Erro ao cancelar o pedido';
                        this.messageService.error(error.message, title, error);
                        btnCancelPedido.reset();
                    }
                );
        }
    }
}
